export default __webpack_public_path__ + "static/media/delivery.52db0469.svg";